// extracted by mini-css-extract-plugin
export default {"heading":"Products_heading__Lb+hX","name":"Products_name__xwFuV","subcontent":"Products_subcontent__DqQh1"};